<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Google Sheets" class="d-icon d-icon--google-sheets" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M5.5 1A1.5 1.5 0 0 0 4 2.5v19A1.5 1.5 0 0 0 5.5 23h13a1.5 1.5 0 0 0 1.5-1.5V7l-6-6H5.5Z" fill="#20A464"/><path d="M5.5 23A1.5 1.5 0 0 1 4 21.5v-.25a1.5 1.5 0 0 0 1.5 1.5h13a1.5 1.5 0 0 0 1.5-1.5v.25a1.5 1.5 0 0 1-1.5 1.5h-13Z" fill="#149456"/><path d="M5.5 1A1.5 1.5 0 0 0 4 2.5v.25a1.5 1.5 0 0 1 1.5-1.5h8.75L14 1H5.5Z" fill="#38AE74"/><path d="M20 12.125V7l-.875-.875h-4.22a.375.375 0 0 0-.265.64l5.36 5.36Z" :fill="`url(#${uniqueID}a)`"/><path d="m14 1 6 6h-4.5A1.5 1.5 0 0 1 14 5.5V1Z" fill="#8ED1B1"/><path fill-rule="evenodd" clip-rule="evenodd" d="M16 11.75V19H8v-7.25h8Zm-4.5 1H9V14h2.5v-1.25Zm1 1.25v-1.25H15V14h-2.5Zm-1 .75H9V16h2.5v-1.25Zm1 1.25v-1.25H15V16h-2.5Zm-1 .75H9V18h2.5v-1.25Zm1 1.25v-1.25H15V18h-2.5Z" fill="#fff"/><defs><linearGradient :id="`${uniqueID}a`" x1="17.265" y1="12.125" x2="17.265" y2="6" gradientUnits="userSpaceOnUse"><stop stop-color="#20A464"/><stop offset="1" stop-color="#207E55"/></linearGradient></defs></svg>
</template>

<script>
import { getUniqueString } from '@/src/utils';
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconGoogleSheets',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
    this.uniqueID = getUniqueString();
  },
};
</script>
